import React from 'react'
import AdminDashSidebarSidebarComp from '../../components/mobile/AdminDashSidebarSidebarComp'
import AssessmentPrintComp from '../../components/adminDashboard/desktop/AssessmentPrintComp'
import AssessmentPrintCompmb from '../../components/adminDashboard/mobile/AssessmentPrintCompmb'

const AssessmentPrintPage = () => {
  return (
   <>
     <div className="desktop">
        <div className="overlayfordrpdwn">
        </div>
        <AssessmentPrintComp/>
      </div>
      <div className="mobile">
        <div className="overlayfordrpdwn"></div>
        <AdminDashSidebarSidebarComp />
        <AssessmentPrintCompmb/>
      </div>
   </>
  )
}

export default AssessmentPrintPage